import { zTariffCommonSchema } from "./tariff.common";
import { z } from "zod";
export const zTariffSchemaDom = zTariffCommonSchema;
export const zTariffSchemaCreateDom = zTariffSchemaDom.omit({ id: true });
// —— FR-003: pair shape consumed by TariffPage / TariffsPage ——
export const zTariffPairDom = z.object({
    advance: zTariffSchemaDom,
    late: zTariffSchemaDom.nullable(),
});
